import { render, staticRenderFns } from "./DataListCardsVIew.vue?vue&type=template&id=830b9ff2&"
import script from "./DataListCardsVIew.vue?vue&type=script&lang=js&"
export * from "./DataListCardsVIew.vue?vue&type=script&lang=js&"
import style0 from "./DataListCardsVIew.vue?vue&type=style&index=0&id=830b9ff2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports